import styled from '@emotion/styled';
import { type CarouselProps } from '@silvertours/front-entities';

const Container = styled.div<CarouselProps>`
  display: flex;
  gap: ${({ theme }) => theme.spacing[50]};

  & > * {
    width: 313px;
  }

  ${({ theme }) => theme.mq('sm')} {
    & > * {
      width: 360px;
    }
  }
`;

const SerpOffersWrapper = styled.div`
  padding-block: 2.5rem;
`;

export { Container, SerpOffersWrapper };
